
import { Link } from 'react-router-dom'
import WandIcon from '../assets/svg/wand-magic.svg?react'
import PlusIcon from '../assets/svg/plus.svg?react'
import { useApp } from '../hooks/useApp.jsx'

export default function BuyCreditsMessage() {
    const { session } = useApp()
    
    const isFreePlan = session?.subscription?.slug === 'free'
    
    if (isFreePlan) {
        return (
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg p-6 text-white shadow-lg">
                <div className="flex items-center gap-3 mb-4">
                    <WandIcon width={28} height={28} className="text-yellow-300" />
                    <h3 className="text-xl font-bold">Unlock Premium Features!</h3>
                </div>
                
                <div className="mb-6">
                    <p className="text-blue-100 mb-3">
                        You&apos;ve reached your free plan&apos;s limits. Upgrade to Premium to unleash your full potential!
                    </p>
                    <ul className="text-sm text-blue-100 space-y-1">
                        <li>• Generate unlimited AI strategies</li>
                        <li>• Access advanced backtesting features</li>
                        <li>• Export results in multiple formats</li>
                        <li>• Priority support and faster processing</li>
                    </ul>
                </div>

                <div className="flex flex-col sm:flex-row gap-3">
                    <Link
                        to="/billing"
                        className="flex-1 bg-white text-blue-600 font-semibold py-3 px-6 rounded-lg hover:bg-gray-100 transition-colors text-center"
                    >
                        Upgrade to Premium
                    </Link>
                </div>
            </div>
        )
    } else {
        return (
            <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg p-6 text-white shadow-lg">
                <div className="flex items-center gap-3 mb-4">
                    <PlusIcon width={28} height={28} className="text-yellow-300" />
                    <h3 className="text-xl font-bold">Need More Credits?</h3>
                </div>
                
                <div className="mb-6">
                    <p className="text-purple-100 mb-3">
                        You&apos;ve used all your available credits. Get more to continue creating amazing strategies!
                    </p>
                    <ul className="text-sm text-purple-100 space-y-1">
                        <li>• Purchase credit add-ons for immediate access</li>
                        <li>• Flexible credit packages to match your needs</li>
                        <li>• Continue your current workflow uninterrupted</li>
                        <li>• Or upgrade your plan for better long-term value</li>
                    </ul>
                </div>

                <div className="flex flex-col sm:flex-row gap-3">
                    <Link
                        to="/billing"
                        className="flex-1 bg-purple-500 bg-opacity-50 text-white font-semibold py-3 px-6 rounded-lg hover:bg-opacity-70 transition-colors text-center border border-purple-400"
                    >
                        Upgrade Plan
                    </Link>
                </div>
            </div>
        )
    }
}
